import Api from '@/api'

export default {
  namespaced: true,
  state: {
    emailNotificationSetting: false,
    reminderSetting: false,
    scheduleList: [],
    notifications: [],
    unreadNotifications: []
  },

  mutations: {
    setEmailNotificationSetting(state, emailNotificationSetting) {
      state.emailNotificationSetting = emailNotificationSetting === 1
    },
    setReminderSetting(state, reminderSetting) {
      state.reminderSetting = reminderSetting
    },
    setScheduleList(state, scheduleList) {
      state.scheduleList = scheduleList
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    setUnreadNotifications(state, unreadNotifications) {
      state.unreadNotifications = unreadNotifications
    }
  },

  actions: {
    async getNotificationSettings({ commit }) {
      const { data } = await Api.get(`notifications/settings`)
      commit('setEmailNotificationSetting', data.data.email_notification_enable)
      commit('setReminderSetting', data.data.expiring_schedule_id.label)
    },
    async getScheduleList({ commit }) {
      const { data } = await Api.get(`notifications/settings/schedule`)
      commit('setScheduleList', data.data)
    },
    async getNotifications({ commit }) {
      const { data } = await Api.get(`notifications`)
      commit('setNotifications', data.data)
    },
    async getUnreadNotifications({ commit }) {
      const { data } = await Api.get(`notifications/unread`)
      commit('setUnreadNotifications', data.data)
    }
  },

  getters: {
    emailNotificationSetting(state) {
      return state.emailNotificationSetting
    },
    reminderSetting(state) {
      return state.reminderSetting
    },
    scheduleList(state) {
      return state.scheduleList
    },
    notifications(state) {
      return state.notifications
    },
    unreadNotifications(state) {
      return state.unreadNotifications
    }
  }
}
